import { render, staticRenderFns } from "./FaqProductComponent.vue?vue&type=template&id=b9c2b57e&scoped=true"
import script from "./FaqProductComponent.vue?vue&type=script&lang=js"
export * from "./FaqProductComponent.vue?vue&type=script&lang=js"
import style0 from "./FaqProductComponent.vue?vue&type=style&index=0&id=b9c2b57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c2b57e",
  null
  
)

export default component.exports